import type { InvariantRoute } from '@atlassian/react-resource-router/src/common/types';

export const forgeProjectRoute: InvariantRoute = {
	name: 'forge-spa-project',
	path: '/jira/:projectType(software|software/c|core)/projects/:projectKey/apps/:appId/:envId/:route?',
};
